import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
export function CateringElite() {
  const kitIncludes = ['Presupuestador automático para eventos grandes', 'Cronograma de producción en serie (20 a 500 sándwiches)', 'Protocolo de equipo para trabajar con ayudantes', 'Plantilla de remito y presupuesto formal', 'Catálogo PDF Premium para eventos', 'Guía de alianzas con Wedding Planners', 'Script de presentación a empresas B2B', 'Calculadora de precio por servicio completo de catering'];
  return <section className="py-14 bg-brand-lightGray" data-id="element-33">
      <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-34">
        <div className="text-center mb-8" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-3" data-id="element-36">
            🕊️ ¿QUÉ AGREGA EL KIT CATERING ELITE?
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-2xl shadow-md overflow-hidden mb-10" data-id="element-37">
          <div className="overflow-x-auto" data-id="element-38">
            <table className="w-full text-left border-collapse" data-id="element-39">
              <thead data-id="element-40">
                <tr className="bg-brand-dark text-white" data-id="element-41">
                  <th className="p-3 md:p-4 font-semibold w-1/3" data-id="element-42">
                    Situación en tu negocio
                  </th>
                  <th className="p-3 md:p-4 font-semibold w-1/3 text-center border-l border-gray-700" data-id="element-43">
                    ❌ Sin Kit
                  </th>
                  <th className="p-3 md:p-4 font-semibold w-1/3 text-center bg-brand-gold border-l border-brand-goldHover" data-id="element-44">
                    ✅ Con Kit
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-45">
                <tr className="hover:bg-gray-50" data-id="element-46">
                  <td className="p-3 md:p-4 text-brand-dark font-medium" data-id="element-47">
                    Cliente pide presupuesto para evento de 150 personas
                  </td>
                  <td className="p-3 md:p-4 text-brand-gray text-center border-l border-gray-200" data-id="element-48">
                    Calculás a ojo y cobrás de menos
                  </td>
                  <td className="p-3 md:p-4 text-brand-dark font-bold text-center bg-brand-cream border-l border-gray-200" data-id="element-49">
                    Presupuesto profesional listo en 5 minutos
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-50">
                  <td className="p-3 md:p-4 text-brand-dark font-medium" data-id="element-51">
                    Tenés que producir 400 sándwiches solo/a
                  </td>
                  <td className="p-3 md:p-4 text-brand-gray text-center border-l border-gray-200" data-id="element-52">
                    No sabés por dónde empezar
                  </td>
                  <td className="p-3 md:p-4 text-brand-dark font-bold text-center bg-brand-cream border-l border-gray-200" data-id="element-53">
                    Cronograma de producción hora por hora
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-54">
                  <td className="p-3 md:p-4 text-brand-dark font-medium" data-id="element-55">
                    Empresa pide remito o presupuesto formal
                  </td>
                  <td className="p-3 md:p-4 text-brand-gray text-center border-l border-gray-200" data-id="element-56">
                    No tenés nada preparado
                  </td>
                  <td className="p-3 md:p-4 text-brand-dark font-bold text-center bg-brand-cream border-l border-gray-200" data-id="element-57">
                    Plantilla de remito profesional lista
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-58">
                  <td className="p-3 md:p-4 text-brand-dark font-medium" data-id="element-59">
                    Organizador de eventos pide catálogo
                  </td>
                  <td className="p-3 md:p-4 text-brand-gray text-center border-l border-gray-200" data-id="element-60">
                    Mandás foto del celular
                  </td>
                  <td className="p-3 md:p-4 text-brand-dark font-bold text-center bg-brand-cream border-l border-gray-200" data-id="element-61">
                    Catálogo PDF de confitería de lujo
                  </td>
                </tr>
                <tr className="hover:bg-gray-50" data-id="element-62">
                  <td className="p-3 md:p-4 text-brand-dark font-medium" data-id="element-63">
                    Necesitás contratar ayuda temporal
                  </td>
                  <td className="p-3 md:p-4 text-brand-gray text-center border-l border-gray-200" data-id="element-64">
                    No sabés cómo coordinar
                  </td>
                  <td className="p-3 md:p-4 text-brand-dark font-bold text-center bg-brand-cream border-l border-gray-200" data-id="element-65">
                    Protocolo de equipo listo para delegar
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* Kit Includes Checklist */}
        <div className="bg-brand-dark text-white rounded-3xl p-6 md:p-8 shadow-xl border border-brand-gold" data-id="element-66">
          <h3 className="text-2xl md:text-3xl font-serif font-bold mb-5 text-center text-brand-gold" data-id="element-67">
            ✅ EL KIT CATERING ELITE INCLUYE:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-68">
            {kitIncludes.map((item, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-69">
                <CheckCircleIcon className="text-brand-gold flex-shrink-0 mt-0.5" data-id="element-70" />
                <span className="text-lg font-medium" data-id="element-71">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}